import {isFundraisingMode} from '~/selectors/LabModeSelectors';
import {
  SIMPLE_PRICING_FLAG,
  UPLOAD_ONE_COLOR_FLAG,
  UPLOAD_AUTO_SIZING_FLAG,
  WAYS_TO_ORDER_FLAG,
  CI_HEADER_FLAG,
  RETRIEVE_DESIGNS,
  DRAG_N_DROP_ANYWHERE_FLAG,
  ADD_TO_CLIPART_FLAG
} from '../constants/FeatureFlags';
import {__DEVELOPMENT__} from '~/utils/env';

export const getSignalValueSelector = flag => state =>
  state.config.get('signals')[flag];

export const getSignalFlagSelector =
  (flag, testValue = 'test') =>
  state =>
    state.config.get('signals')[flag] === testValue;

export const getSignalFlagSelectorRegex =
  (flag, testValue = 'test') =>
  state =>
    state.config.get('signals')[flag] &&
    state.config.get('signals')[flag].match(testValue);

export const isCartMode = () => false;

export const defaultBlankValue = state => {
  return getSignalValueSelector('defaultBlank_v9')(state);
};

export const isStreamlinedMobileMode = state =>
  state.config.get('streamlinedMobileMode');

export const streamlinedMobileIntent = state =>
  state.config.get('streamlinedMobileIntent');

export const isSleeveDecoEligible = state => {
  if (state.mode && isFundraisingMode(state)) {
    return false;
  }
  if (state.config.get('sleevePrintOverride') !== null) {
    return state.config.get('sleevePrintOverride');
  }
  return false;
};

export const isMultiItemEligible = () => true;

export const isOosEligible = () => true;

export const uploadColorRemoval = state =>
  getSignalFlagSelector('uploadColorRemoval')(state);

export const isLabExitWarningEligible = state =>
  !__DEVELOPMENT__ && state.config.get('exitWarningEligible');

export const cartCookie = () => ({
  email: '',
  postalCode: '',
  orderItemCount: 0
});

export const cartCookiePostalCode = state => cartCookie(state).postalCode;
export const cartCookieEmail = state => cartCookie(state).email;

export const rebrandTestFlag = state => state.config.get('signals').rebrand;

export const clipartRecoloringOverride = state =>
  state.config.get('clipartRecoloringOverride');

export const designLastSavedSession = state => state.config.get('lastSaved');

export const retrieveDesignsValue = state => getSignalValueSelector()(state);
export const isRetrieveDesignsActive = state => {
  const flag = getSignalValueSelector(RETRIEVE_DESIGNS)(state);
  return flag === 'test';
};

export const autoFitTextFlag = 'autoFitText';
export const isAutoFitTextEnabled = state =>
  getSignalFlagSelectorRegex(autoFitTextFlag)(state);
export const autoFitTextFlagValue = state =>
  getSignalValueSelector(autoFitTextFlag)(state);

export const collaborationFlag = 'collaboration_v5';
export const collaborationTestValue = state =>
  getSignalValueSelector(collaborationFlag)(state);
export const collaborationTestEnabled = state =>
  getSignalFlagSelector(collaborationFlag)(state);

export const singlesContentAlertEnabled = () => true;

export const singlesPricingMessageFlag = 'singlesPricingMessage_v4';
export const singlesPricingMessageTestValue = state =>
  getSignalValueSelector(singlesPricingMessageFlag)(state);
export const singlesPricingMessageEnabled = state =>
  getSignalFlagSelector(singlesPricingMessageFlag)(state);

export const uploadResFlag = 'uploadResolution_v3';
export const uploadResTestValue = state =>
  getSignalValueSelector(uploadResFlag)(state);
export const uploadResTestEnabled = state =>
  getSignalFlagSelector(uploadResFlag)(state);

// optimize WTO test
export const wtoTest = WAYS_TO_ORDER_FLAG;
export const wtoTestValue = state => getSignalValueSelector(wtoTest)(state);
export const wtoTestEnabled = state => {
  return getSignalFlagSelector(wtoTest)(state);
};

export const decorationOverrides = 'decoration_overrides_v1';
export const decorationOverridesEnabled = state =>
  getSignalFlagSelector(decorationOverrides)(state);

export const getSimplePricingTestValue = state =>
  getSignalValueSelector(SIMPLE_PRICING_FLAG)(state);
export const simplePricingTestEnabled = state =>
  getSignalFlagSelector(SIMPLE_PRICING_FLAG)(state);

export const isCiHeaderEnabledValue = state =>
  getSignalValueSelector(SIMPLE_PRICING_FLAG)(state);
export const isCiHeaderEnabled = state =>
  getSignalFlagSelector(CI_HEADER_FLAG)(state);
export const isDragNDropAnywhereEnabled = state =>
  getSignalFlagSelector(DRAG_N_DROP_ANYWHERE_FLAG)(state);
export const isAddToClipartEnabled = state =>
  getSignalFlagSelector(ADD_TO_CLIPART_FLAG)(state);
export const isAddToClipartEnabledValue = state =>
  getSignalValueSelector(ADD_TO_CLIPART_FLAG)(state);

export const isUploadOneColorEnabled = state =>
  getSignalFlagSelector(UPLOAD_ONE_COLOR_FLAG)(state);
export const uploadOneColorTestValue = state =>
  getSignalValueSelector(UPLOAD_ONE_COLOR_FLAG)(state);

export const isUploadAutoSizingEnabled = state =>
  getSignalFlagSelector(UPLOAD_AUTO_SIZING_FLAG)(state);

export const promoFlag = 'drinkware_promo_ad_v2';

export const promoFlagTestValue = state => {
  return getSignalValueSelector(promoFlag)(state);
};
